import { useTimeout } from '@mantine/hooks';
import { modals } from '@mantine/modals';
import type { TranslateFn } from '@newo/localization';
import { type FC, useEffect, useState } from 'react';

const FINALIZATION_DURATION_MS = 10000;

type ChatFlowFinalModalProps = {
	modalId: string;
	translate: TranslateFn;
};

const ChatFlowFinalModal: FC<ChatFlowFinalModalProps> = ({
	modalId,
	translate
}) => {
	const [progress, setProgress] = useState(0);
	const closeTimeout = useTimeout(() => {
		modals.close(modalId);
	}, FINALIZATION_DURATION_MS);

	// biome-ignore lint/correctness/useExhaustiveDependencies: start once on mount
	useEffect(() => {
		setProgress(100);
		closeTimeout.start();

		return () => {
			closeTimeout.clear();
		};
	}, []);

	return (
		<div className="w-[min(88vw,440px)] px-2 py-1">
			<div className="mt-5">
				<div className="mb-2 text-center font-medium">
					{translate('creator', 'chatFlow.finalizationModal.title')}
				</div>

				<div className="h-5 overflow-hidden rounded-full bg-[rgba(232,232,232,0.8)]">
					<div
						className="h-full rounded-full bg-primary-900 transition-[width] ease-linear"
						style={{
							transitionDuration: `${FINALIZATION_DURATION_MS}ms`,
							width: `${progress}%`
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default ChatFlowFinalModal;
